import { render, staticRenderFns } from "./obsLive.vue?vue&type=template&id=7ba94274&"
import script from "./obsLive.vue?vue&type=script&lang=js&"
export * from "./obsLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports